var render = function render(){var _vm=this,_c=_vm._self._c;return _c('test-passage',{attrs:{"test-id":parseInt(_vm.$route.params.id)}})
}
var staticRenderFns = []

export { render, staticRenderFns }